import { Dialog, type DialogProps } from "@mui/material";
import { useIsMobile } from "@/shared/hooks/useIsMobile";

/**
 * MUI Dialog sarmalayıcı: mobilde (md altı) otomatik tam ekran açar. Gelen tüm proplar
 * (maxWidth, PaperProps, fullScreen vb.) aynen iletilir; açıkça verilen fullScreen üstündür.
 */
export const ResponsiveDialog = ({ children, fullScreen, ...props }: DialogProps) => {
  const isMobile = useIsMobile();
  return (
    <Dialog fullScreen={fullScreen ?? isMobile} {...props}>
      {children}
    </Dialog>
  );
};
